import UniData from '@/common/classes/UniData'
import { extractUniDataFieldFromHookResult } from '@/common/utils/treeTableGetData'

/** Поля, относящиеся к элементу: name, name__*, name.*  */
export function isElementScopedFieldKey(key: string, fieldName: string): boolean {
  if (!fieldName) return false
  return key === fieldName || key.startsWith(`${fieldName}__`) || key.startsWith(`${fieldName}.`)
}

export function scopeUniDataToElementField(raw: unknown, fieldName: string): UniData {
  if (!fieldName) {
    return raw instanceof UniData ? raw : new UniData()
  }

  if (raw instanceof UniData) {
    const all = raw._getAllFields()
    const keys = Object.keys(all).filter((k) => isElementScopedFieldKey(k, fieldName))
    if (keys.length === 0 && raw.hasField(fieldName)) {
      const scoped = new UniData()
      scoped.setField(fieldName, raw.getField(fieldName))
      return scoped
    }
    if (keys.length === Object.keys(all).length) {
      return raw
    }
    const scoped = new UniData()
    for (const key of keys) {
      scoped.setField(key, raw.getField(key))
    }
    return scoped
  }

  const hookField = extractUniDataFieldFromHookResult(raw, fieldName)
  if (hookField !== undefined) {
    const scoped = new UniData()
    scoped.setField(fieldName, hookField)
    return scoped
  }

  return new UniData()
}
